import React from 'react';

function StarRating({ rating = 0, maxStars = 5, className = '', size = 'md' }) {
  const safeRating = Math.max(0, Math.min(maxStars, Number(rating) || 0));

  return (
    <span
      className={`tsr-star-rating tsr-star-rating--${size} ${className}`.trim()}
      role="img"
      aria-label={`${safeRating} out of ${maxStars} stars`}
    >
      {Array.from({ length: maxStars }, (_, index) => {
        const fill = Math.max(0, Math.min(1, safeRating - index));
        return (
          <span key={index} className="tsr-star-rating__star" aria-hidden="true">
            <i className="fas fa-star tsr-star-rating__star-bg" />
            <span className="tsr-star-rating__star-fill" style={{ width: `${fill * 100}%` }}>
              <i className="fas fa-star" />
            </span>
          </span>
        );
      })}
    </span>
  );
}

export default StarRating;
